<div class="app-container" [ngClass]="{ 'bg-light': account }">
    <!-- main nav -->

    <nav class="navbar navbar-expand-md navbar-dark bg-dark" *ngIf="account">
        <a class="navbar-brand" href="#">
            <img src="assets/logo/aisyte-logo.png" width=100px alt="">
        </a>
        <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarCollapse">
            <div class="navbar-nav">
                <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-item nav-link">Dashboard</a>
                <a routerLink="/alert" routerLinkActive="active" class="nav-item nav-link">Alerts</a>
                <a routerLink="/configure" routerLinkActive="active" class="nav-item nav-link">Configuration</a>
                <a routerLink="/report" routerLinkActive="active" class="nav-item nav-link">Reports</a>
            </div>
            <div class="navbar-nav ml-auto">
                <a *ngIf="account.role === Role.Admin" routerLink="/admin" routerLinkActive="active" class="nav-item nav-link">Admin</a>
                <a routerLink="/profile" routerLinkActive="active" class="nav-item nav-link">{{account.firstName}}</a>
                <a (click)="logout()" class="nav-item nav-link">Logout</a>
            </div>
        </div>
    </nav>

    <!-- subnav router outlet -->
    <router-outlet name="subnav"></router-outlet>

    <!-- global alert -->
    <alert></alert>

    <!-- main router outlet -->
    <router-outlet></router-outlet>
</div>
